module.exports = __webpack_public_path__ + "static/media/01_avatar_animal.64804fa3.png";